<template>
    <v-dialog v-model="dialog" width="600px">
        <v-card>
            <p class=".title ma-2">{{ hsft.huis_code }} </p>
            <v-carousel v-model="hsft.eerste_foto" hide-delimiters :continuous=false height="575px">
                <v-carousel-item v-for="(hsftRecord, i) in reactivePhotoArray" :key="i">
                    <v-img :src="hsftRecord.hsft_foto" width="600" height="450"></v-img>
                    <v-container>
                        <v-row dense class="flex">
                            <div :style="{ color: 'black' }" @click="showOrigineel(hsftRecord.hsft_fotoOrigineel)" class="mr-3">Nr: {{ hsftRecord.hsft_nr }}</div>
                            <div v-if="hsftRecord.fttgtaal_oms === 'No TAG'" @click="updHsft2(hsftRecord.hsft_encrid)" :style="{ color: 'orange' }" class="mr-3">No TAG</div>
                            <div :style="{ color: 'black' }" v-else @click="updHsft2(hsftRecord.hsft_encrid)" class="mr-3">TAG: {{ hsftRecord.fttgtaal_oms }} </div>
                            <div v-if="hsftRecord.hsft_portrait" :style="{ color: 'red' }" class="mr-3">Portrait</div>
                            <div v-if="hsftRecord.hsft_not_unique !== ''" :style="{ color: 'orange' }">Photo not unique. See ({{ hsftRecord.hsft_not_unique }})</div>
                        </v-row>
                        <v-row dense class="flex">
                            <div v-if="hsftRecord.hsft_size_error" :style="{ color: 'red' }" class="mr-3">Width x Height: {{ hsftRecord.hsft_size_error }} </div>
                            <div v-if="hsftRecord.hsft_size_warning" :style="{ color: 'orange' }" class="mr-3">Width x Height: {{ hsftRecord.hsft_size_warning }} </div>
                            <div :style="{ color: 'black' }" v-if="hsftRecord.hsft_size" class="mr-3">Width x Height: {{ hsftRecord.hsft_size }} </div>
                            <div :style="{ color: 'black' }">Uploaded: {{ hsftRecord.uploaded }}</div>
                        </v-row>
                        
                        <v-row dense class="flex pb-2">
                            <v-spacer></v-spacer>
                            <span :style="{ color: 'red' }" v-if="confirmCounter > 0">Press "confirm delete" to confirm delete of the Photo ({{ confirmCounter }})</span>
                            <span v-else>&nbsp;</span>
                        </v-row>

                        <v-row dense class="flex">
                            <v-spacer />
                            <!-- <v-btn class="warning mr-3" small @click="rmHsftConfirm()" v-if="confirmCounter <= 0">Delete</v-btn>
                            <v-btn class="warning mr-3" small @click="rmHsft(hsftRecord.hsft_encrid)" v-else>Confirm Delete</v-btn> -->
                            <v-btn color="primary" small @click="dialog = false">Close</v-btn>
                        </v-row>
                    </v-container>
                </v-carousel-item>
        </v-carousel>
        <updHsft2 ref="updHsft2" @updateData="updateData" @updateHsft="updateHsft"></updHsft2>
    </v-card>
</v-dialog></template>

<script>
import updHsft2 from "@/views/huis/hsft/updHsft2.vue"
// import { bus } from "../../../main";

export default {
    components: {
        updHsft2
    },
    data() { 
        return {
            dialog: false,
            confirmTimer: null,
            confirmCounter: 0,
            fttg_nrKeuzes: [],
            hsft: {},
            hsft_array: []
        }
    },
    computed: {
        reactivePhotoArray: function () {
            return this.hsft_array.filter(() => {
                return true;
            });
        }
    },
    methods: {
        open(hsft_encrid) {
            this.$emit("showSnackbar");
            this.getPhoto(hsft_encrid);
            this.dialog = true;
        },
        updHsft2(hsft_encrid) {
            this.$refs.updHsft2.open(hsft_encrid);
        },
        getPhoto(hsft_encrid) {
            this.$axios
                .post("ares/json/ares/huis/hsft/getHsftHsfo.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsftHsfo"
                    },
                    getHsftHsfo: {
                        hsft_encrid: hsft_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hsft = res.data.getHsftHsfo;
                        this.hsft_array = res.data.getHsftHsfo.hsft;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateData(data) {
            let idx = this.hsft_array.findIndex(photo => photo.hsft_encrid === data[0].value);
            if (idx !== -1) {
                this.hsft_array[idx].fttg_nr = data[1].value;
                this.hsft_array[idx].fttgtaal_oms = data[2].value;
            }
        },
        updateHsft(){
            this.$emit("updateData");
        },

        rmHsftConfirmCountdown() {
            this.confirmCounter -= 1;
            if (this.confirmCounter <= 0) {
                clearInterval(this.confirmTimer);
            }
        },
        rmHsftConfirm() {
            this.confirmCounter = 5;
            this.confirmTimer = setInterval(this.rmHsftConfirmCountdown, 1000);
        },
        rmHsft(hsft_encrid) {
            this.$axios
                .post("ares/json/ares/huis/hsft/rmHsft.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmHsft"
                    },
                    rmHsft: {
                        hsft_encrid: hsft_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {

                        // if (res.data.rmHsft.color == "success") { 
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.rmHsft.text,
                            color: res.data.rmHsft.color
                        });
                        this.$emit('updateData');
                        this.dialog = false;
                    }
                })
        },
        showOrigineel(url) {
            window.open(url, '_blank');
        }
    }
}
</script>

<style scoped>
.flex{
    display: flex;
    flex-direction: row;
}
</style>
